// client/src/pages/PrivacyPolicy/PrivacyPolicy.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import * as S from './PrivacyPolicy.style';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    const closed = window.close();
    
    setTimeout(() => {
      if (!closed) {
        navigate(-1);
      }
    }, 100);
  };

  return (
    <S.PrivacyPolicyContainer>
      <S.PrivacyPolicyCard>
        <S.Header>
          <S.BackButton onClick={handleGoBack}>
            ← 돌아가기
          </S.BackButton>
          <S.Title>개인정보 처리방침</S.Title>
          <S.EffectiveDate>시행일자: 2025년 1월 1일</S.EffectiveDate>
        </S.Header>

        <S.Content>
          <S.Section>
            <S.SectionTitle>1. 개인정보의 처리 목적</S.SectionTitle>
            <S.Paragraph>
              <strong>Pivo</strong>는 다음의 목적을 위하여 개인정보를 처리하고 있으며, 
              다음의 목적 이외의 용도로는 이용하지 않습니다.
            </S.Paragraph>
            <S.List>
              <S.ListItem>회원 가입의사 확인 및 본인 식별·인증</S.ListItem>
              <S.ListItem>회원자격 유지 및 관리</S.ListItem>
              <S.ListItem>데이터 분석 서비스 제공</S.ListItem>
              <S.ListItem>업로드된 파일 관리 및 보고서 생성 서비스 제공</S.ListItem>
              <S.ListItem>서비스 이용에 따른 본인 확인 및 부정 이용 방지</S.ListItem>
            </S.List>
          </S.Section>

          <S.Section>
            <S.SectionTitle>2. 개인정보의 처리 및 보유 기간</S.SectionTitle>
            <S.SubSection>
              <S.SubSectionTitle>① 처리 및 보유 기간</S.SubSectionTitle>
              <S.Paragraph>
                Pivo는 정보주체로부터 개인정보를 수집할 때 동의 받은 개인정보 보유·이용기간 
                또는 법령에 따른 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.
              </S.Paragraph>
            </S.SubSection>

            <S.SubSection>
              <S.SubSectionTitle>② 구체적인 보유 기간</S.SubSectionTitle>
              <S.List>
                <S.ListItem>
                  <strong>회원 가입 및 관리:</strong> 서비스 이용계약 체결 시부터 
                  서비스 이용계약 해지 시까지
                </S.ListItem>
                <S.ListItem>
                  <strong>보유 기간:</strong> 회원 탈퇴 시 지체없이 파기 
                  (단, 관계 법령에 따라 보존할 필요가 있는 경우 해당 기간 동안 보관)
                </S.ListItem>
              </S.List>
            </S.SubSection>

            <S.SubSection>
              <S.SubSectionTitle>③ 법령에 따른 개인정보 보존 기간</S.SubSectionTitle>
              <S.List>
                <S.ListItem>
                  <strong>계약 또는 청약철회 등에 관한 기록:</strong> 5년 
                  (전자상거래 등에서의 소비자보호에 관한 법률)
                </S.ListItem>
                <S.ListItem>
                  <strong>대금결제 및 재화 등의 공급에 관한 기록:</strong> 5년 
                  (전자상거래 등에서의 소비자보호에 관한 법률)
                </S.ListItem>
                <S.ListItem>
                  <strong>소비자의 불만 또는 분쟁처리에 관한 기록:</strong> 3년 
                  (전자상거래 등에서의 소비자보호에 관한 법률)
                </S.ListItem>
                <S.ListItem>
                  <strong>웹사이트 방문기록:</strong> 3개월 (통신비밀보호법)
                </S.ListItem>
              </S.List>
            </S.SubSection>
          </S.Section>

          <S.Section>
            <S.SectionTitle>3. 정보주체와 법정대리인의 권리·의무 및 그 행사방법</S.SectionTitle>
            <S.Paragraph>
              이용자는 개인정보주체로서 다음과 같은 권리를 행사할 수 있습니다.
            </S.Paragraph>
            
            <S.SubSection>
              <S.SubSectionTitle>① 행사 가능한 권리</S.SubSectionTitle>
              <S.NumberedList>
                <S.ListItem>개인정보 열람 요구</S.ListItem>
                <S.ListItem>오류 등이 있을 경우 정정 요구</S.ListItem>
                <S.ListItem>삭제 요구</S.ListItem>
                <S.ListItem>처리정지 요구</S.ListItem>
              </S.NumberedList>
            </S.SubSection>

            <S.SubSection>
              <S.SubSectionTitle>② 권리 행사 방법</S.SubSectionTitle>
              <S.Paragraph>
                권리 행사는 Pivo에 대해 서면, 전화, 전자우편 등을 통하여 하실 수 있으며, 
                Pivo는 이에 대해 지체없이 조치하겠습니다.
              </S.Paragraph>
            </S.SubSection>
          </S.Section>

          <S.Section>
            <S.SectionTitle>4. 처리하는 개인정보의 항목</S.SectionTitle>
            
            <S.InfoBox>
              <S.InfoBoxTitle>■ 회원 가입 시</S.InfoBoxTitle>
              <S.InfoBoxContent>
                <S.InfoRow>
                  <S.InfoLabel>필수항목</S.InfoLabel>
                  <S.InfoValue>
                    이름(username), 이메일(email), 비밀번호(암호화 저장), 
                    소속 기관(organization), 부서(department)
                  </S.InfoValue>
                </S.InfoRow>
                <S.InfoRow>
                  <S.InfoLabel>수집목적</S.InfoLabel>
                  <S.InfoValue>
                    회원 식별 및 본인 인증, 서비스 제공 및 회원 관리, 
                    데이터 분석 서비스 이용
                  </S.InfoValue>
                </S.InfoRow>
                <S.InfoRow>
                  <S.InfoLabel>보유기간</S.InfoLabel>
                  <S.InfoValue>
                    회원 탈퇴 또는 동의철회 시 지체없이 파기
                  </S.InfoValue>
                </S.InfoRow>
              </S.InfoBoxContent>
            </S.InfoBox>

            <S.InfoBox>
              <S.InfoBoxTitle>■ 서비스 이용 시 자동 생성·수집되는 정보</S.InfoBoxTitle>
              <S.InfoBoxContent>
                <S.InfoRow>
                  <S.InfoLabel>수집항목</S.InfoLabel>
                  <S.InfoValue>
                    서비스 이용기록, 접속 로그 정보, 
                    업로드 파일 메타데이터(파일명, 파일크기, 파일형식, 업로드 일시), 
                    생성된 보고서 정보
                  </S.InfoValue>
                </S.InfoRow>
                <S.InfoRow>
                  <S.InfoLabel>수집목적</S.InfoLabel>
                  <S.InfoValue>
                    서비스 제공 및 운영, 부정 이용 방지, 서비스 개선 및 통계 분석
                  </S.InfoValue>
                </S.InfoRow>
                <S.InfoRow>
                  <S.InfoLabel>보유기간</S.InfoLabel>
                  <S.InfoValue>
                    회원 탈퇴 후 즉시 파기 (단, 법령에 따른 보존 의무가 있는 경우 해당 기간 동안 보관)
                  </S.InfoValue>
                </S.InfoRow>
              </S.InfoBoxContent>
            </S.InfoBox>

            <S.Paragraph>
              <strong>※ 주의사항</strong>
            </S.Paragraph>
            <S.List>
              <S.ListItem>
                Pivo는 개인정보 보호법 제23조(민감정보의 처리 제한)에 따른 
                민감정보를 수집하지 않습니다.
              </S.ListItem>
            </S.List>
          </S.Section>

          <S.Section>
            <S.SectionTitle>5. 개인정보의 파기</S.SectionTitle>
            <S.Paragraph>
              Pivo는 원칙적으로 개인정보 처리목적이 달성된 경우에는 지체없이 
              해당 개인정보를 파기합니다.
            </S.Paragraph>

            <S.SubSection>
              <S.SubSectionTitle>파기절차</S.SubSectionTitle>
              <S.Paragraph>
                이용자가 입력한 정보는 목적 달성 후 별도의 DB에 옮겨져 내부 방침 및 
                기타 관련 법령에 따라 일정기간 저장된 후 혹은 즉시 파기됩니다. 
                이 때, DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 
                다른 목적으로 이용되지 않습니다.
              </S.Paragraph>
            </S.SubSection>

            <S.SubSection>
              <S.SubSectionTitle>파기기한</S.SubSectionTitle>
              <S.Paragraph>
                이용자의 개인정보는 개인정보의 보유기간이 경과된 경우에는 
                보유기간의 종료일로부터 5일 이내에, 개인정보의 처리 목적 달성, 
                해당 서비스의 폐지, 사업의 종료 등 그 개인정보가 불필요하게 되었을 때에는 
                개인정보의 처리가 불필요한 것으로 인정되는 날로부터 5일 이내에 
                그 개인정보를 파기합니다.
              </S.Paragraph>
            </S.SubSection>

            <S.SubSection>
              <S.SubSectionTitle>파기방법</S.SubSectionTitle>
              <S.List>
                <S.ListItem>
                  <strong>전자적 파일 형태:</strong> 복구 및 재생이 불가능한 
                  기술적 방법을 사용하여 완전히 삭제
                </S.ListItem>
              </S.List>
            </S.SubSection>
          </S.Section>

          <S.Section>
            <S.SectionTitle>6. 개인정보 자동 수집 장치의 설치·운영 및 거부</S.SectionTitle>
            
            <S.SubSection>
              <S.SubSectionTitle>① 쿠키(Cookie)의 사용</S.SubSectionTitle>
              <S.Paragraph>
                Pivo는 개별적인 맞춤서비스를 제공하기 위해 이용정보를 저장하고 
                수시로 불러오는 '쿠키(cookie)'를 사용합니다.
              </S.Paragraph>
            </S.SubSection>

            <S.SubSection>
              <S.SubSectionTitle>② 쿠키의 사용 목적</S.SubSectionTitle>
              <S.List>
                <S.ListItem>이용자의 로그인 상태 유지</S.ListItem>
                <S.ListItem>서비스 이용 기록 및 통계 분석</S.ListItem>
                <S.ListItem>이용자에게 최적화된 정보 제공</S.ListItem>
              </S.List>
            </S.SubSection>

            <S.SubSection>
              <S.SubSectionTitle>③ 쿠키 설정 거부 방법</S.SubSectionTitle>
              <S.Paragraph>
                웹브라우저에서 쿠키 저장을 거부할 수 있습니다:
              </S.Paragraph>
              <S.List>
                <S.ListItem>
                  <strong>Chrome:</strong> 설정 &gt; 개인정보 및 보안 &gt; 
                  쿠키 및 기타 사이트 데이터
                </S.ListItem>
                <S.ListItem>
                  <strong>Edge:</strong> 설정 &gt; 쿠키 및 사이트 권한
                </S.ListItem>
                <S.ListItem>
                  <strong>Safari:</strong> 환경설정 &gt; 개인정보 &gt; 
                  쿠키 및 웹 사이트 데이터
                </S.ListItem>
              </S.List>
              <S.WarningBox>
                ⚠️ 쿠키 저장을 거부할 경우 로그인이 필요한 서비스 이용에 
                어려움이 발생할 수 있습니다.
              </S.WarningBox>
            </S.SubSection>
          </S.Section>

          <S.Section>
            <S.SectionTitle>7. 개인정보 보호책임자</S.SectionTitle>
            <S.Paragraph>
              Pivo는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 
              개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 
              개인정보 보호책임자를 지정하고 있습니다.
            </S.Paragraph>

            <S.ContactBox>
              <S.ContactTitle>▶ 개인정보 보호책임자</S.ContactTitle>
              <S.ContactInfo>
                <S.ContactRow>
                  <S.ContactLabel>성명:</S.ContactLabel>
                  <S.ContactValue>[김혜린]</S.ContactValue>
                </S.ContactRow>
                <S.ContactRow>
                  <S.ContactLabel>직책:</S.ContactLabel>
                  <S.ContactValue>[삼육대학교 약학대학 부교수]</S.ContactValue>
                </S.ContactRow>
                <S.ContactRow>
                  <S.ContactLabel>연락처:</S.ContactLabel>
                  <S.ContactValue>[02-3399-1625], [kimhye-lin@syu.ac.kr]</S.ContactValue>
                </S.ContactRow>
              </S.ContactInfo>
            </S.ContactBox>

            <S.Paragraph>
              Pivo의 서비스를 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 
              불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자에게 
              문의하실 수 있습니다.
            </S.Paragraph>
          </S.Section>

          <S.Section>
            <S.SectionTitle>8. 개인정보의 안전성 확보 조치</S.SectionTitle>
            <S.Paragraph>
              Pivo는 개인정보보호법 제29조에 따라 다음과 같이 안전성 확보에 
              필요한 기술적/관리적 및 물리적 조치를 하고 있습니다.
            </S.Paragraph>

            <S.List>
              <S.ListItem>
                <strong>개인정보 취급 직원의 최소화 및 교육</strong><br />
                개인정보를 취급하는 직원을 지정하고 담당자에 한정시켜 
                최소화하여 개인정보를 관리하는 대책을 시행하고 있습니다.
              </S.ListItem>
              <S.ListItem>
                <strong>내부관리계획의 수립 및 시행</strong><br />
                개인정보의 안전한 처리를 위하여 내부관리계획을 수립하고 
                시행하고 있습니다.
              </S.ListItem>
              <S.ListItem>
                <strong>개인정보의 암호화</strong><br />
                이용자의 비밀번호는 암호화되어 저장 및 관리되고 있으며, 
                중요한 데이터는 파일 및 전송 데이터를 암호화하고 있습니다.
              </S.ListItem>
              <S.ListItem>
                <strong>개인정보에 대한 접근 제한</strong><br />
                개인정보를 처리하는 데이터베이스시스템에 대한 접근권한을 통제하고 
                침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있습니다.
              </S.ListItem>
            </S.List>
          </S.Section>

          <S.Section>
            <S.SectionTitle>9. 권익침해 구제방법</S.SectionTitle>
            <S.Paragraph>
              개인정보 침해에 대한 피해구제, 상담 등이 필요하신 경우 
              아래 기관에 문의하실 수 있습니다.
            </S.Paragraph>

            <S.ContactBox>
              <S.ContactTitle>▶ 개인정보 침해신고센터 (한국인터넷진흥원)</S.ContactTitle>
              <S.ContactInfo>
                <S.ContactRow>
                  <S.ContactLabel>전화:</S.ContactLabel>
                  <S.ContactValue>(국번없이) 118</S.ContactValue>
                </S.ContactRow>
                <S.ContactRow>
                  <S.ContactLabel>홈페이지:</S.ContactLabel>
                  <S.ContactValue>
                    <S.ExternalLink href="https://privacy.kisa.or.kr" target="_blank" rel="noopener noreferrer">
                      privacy.kisa.or.kr
                    </S.ExternalLink>
                  </S.ContactValue>
                </S.ContactRow>
              </S.ContactInfo>
            </S.ContactBox>

            <S.ContactBox>
              <S.ContactTitle>▶ 개인정보 분쟁조정위원회</S.ContactTitle>
              <S.ContactInfo>
                <S.ContactRow>
                  <S.ContactLabel>전화:</S.ContactLabel>
                  <S.ContactValue>(국번없이) 1833-6972</S.ContactValue>
                </S.ContactRow>
                <S.ContactRow>
                  <S.ContactLabel>홈페이지:</S.ContactLabel>
                  <S.ContactValue>
                    <S.ExternalLink href="https://www.kopico.go.kr" target="_blank" rel="noopener noreferrer">
                      www.kopico.go.kr
                    </S.ExternalLink>
                  </S.ContactValue>
                </S.ContactRow>
              </S.ContactInfo>
            </S.ContactBox>

            <S.ContactBox>
              <S.ContactTitle>▶ 대검찰청 사이버범죄수사단</S.ContactTitle>
              <S.ContactInfo>
                <S.ContactRow>
                  <S.ContactLabel>전화:</S.ContactLabel>
                  <S.ContactValue>02-3480-3573</S.ContactValue>
                </S.ContactRow>
                <S.ContactRow>
                  <S.ContactLabel>홈페이지:</S.ContactLabel>
                  <S.ContactValue>
                    <S.ExternalLink href="https://www.spo.go.kr" target="_blank" rel="noopener noreferrer">
                      www.spo.go.kr
                    </S.ExternalLink>
                  </S.ContactValue>
                </S.ContactRow>
              </S.ContactInfo>
            </S.ContactBox>

            <S.ContactBox>
              <S.ContactTitle>▶ 경찰청 사이버안전국</S.ContactTitle>
              <S.ContactInfo>
                <S.ContactRow>
                  <S.ContactLabel>전화:</S.ContactLabel>
                  <S.ContactValue>182</S.ContactValue>
                </S.ContactRow>
                <S.ContactRow>
                  <S.ContactLabel>홈페이지:</S.ContactLabel>
                  <S.ContactValue>
                    <S.ExternalLink href="http://cyberbureau.police.go.kr" target="_blank" rel="noopener noreferrer">
                      cyberbureau.police.go.kr
                    </S.ExternalLink>
                  </S.ContactValue>
                </S.ContactRow>
              </S.ContactInfo>
            </S.ContactBox>
          </S.Section>

          <S.Section>
            <S.SectionTitle>10. 개인정보 처리방침 변경</S.SectionTitle>
            <S.List>
              <S.ListItem>
                이 개인정보 처리방침은 2025년 1월 1일부터 적용됩니다.
              </S.ListItem>
              <S.ListItem>
                이 개인정보 처리방침이 변경될 경우, 변경사항의 시행 7일 전부터 
                서비스 공지사항을 통하여 고지할 것입니다.
              </S.ListItem>
              <S.ListItem>
                중요한 변경사항이 있을 경우에는 시행 30일 전에 공지하며, 
                필요 시 이용자의 동의를 다시 받을 수 있습니다.
              </S.ListItem>
            </S.List>
          </S.Section>
        </S.Content>

        <S.Footer>
          <S.FooterButton onClick={handleGoBack}>
            확인
          </S.FooterButton>
        </S.Footer>
      </S.PrivacyPolicyCard>
    </S.PrivacyPolicyContainer>
  );
};

export default PrivacyPolicy;